// extracted by mini-css-extract-plugin
export default {"app_root":"App_app_root__g0W0q","app_header":"App_app_header__ySZ8P","app_body":"App_app_body__sC81L"};